module.exports = __webpack_public_path__ + "img/party_mode.71519cfd.svg";